<template>
  <div class="accrual-number">
    {{ valueNumber }}
  </div>
</template>
<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AccrualNumber',
  props: {
    valueNumber: {
      type: Number,
      default: 0,
    },
  },
})
</script>

<style scoped lang="scss">
@import '@/assets/styles/colors.scss';
@import '@/widgets/accruals-table/styles/typography.scss';

.accrual-number {
  color: $dark-400;
  @include base-text;
}
</style>
